import { render } from "./Boosts.vue?vue&type=template&id=23ef87d2&scoped=true"
import script from "./Boosts.vue?vue&type=script&lang=js"
export * from "./Boosts.vue?vue&type=script&lang=js"

import "./Boosts.vue?vue&type=style&index=0&id=23ef87d2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ef87d2"]])

export default __exports__